// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if ({353:1,785:1}[chunkId]) return "canvas.56c505249cb48e1a45aa.css";
	if (chunkId === 189) return "editor.7514a8d1865b2b126b7c.css";
	if (chunkId === 35) return "player.ac96576582c8606bf7ab.css";
	if (chunkId === 231) return "checkout.39b079ea27a80804d621.css";
	if (chunkId === 524) return "checkoutEdu.d6de9eb95283d2420d81.css";
	if (chunkId === 559) return "gdrive.99c37209d11cb2d7f8d4.css";
	if (chunkId === 437) return "slack.30c632904b778041d8bd.css";
	// return url for filenames based on template
	return undefined;
};